import { IBounds } from '@umu/umu-types';
import getElementBounds from './getElementBounds';

export default function (container: HTMLElement | Window): IBounds {
    if (!container) {
        return container;
    }
    if (container === window) {
        return {
            top: window.pageYOffset,
            left: window.pageXOffset,
            bottom: window.pageYOffset + window.innerHeight,
            right: window.pageXOffset + window.innerWidth,
        };
    }
    const htmlContainer = container as HTMLElement;
    const bounds = getElementBounds(htmlContainer);
    if (bounds) {
        return {
            ...bounds,
            bottom: bounds.top + htmlContainer.offsetHeight,
            right: bounds.left + htmlContainer.offsetWidth,
        };
    } else {
        return bounds;
    }
}
